<template>
    <div class="homestay">
        <div class="banner">
            <!--<div class="back back-btn">-->
            <!--<i class="iconfont icon-back"></i>-->
            <!--</div>-->
            <!--<div class="back more-btn">-->
            <!--<i class="iconfont icon-more"></i>-->
            <!--</div>-->
            <!-- <div class="homestay-number">
                <span class="num">{{HomeStayNums}}</span>
                <br>
                <span>家客栈民宿可供预订</span>
            </div> -->
            <div class="search-box">
                <div class="search-content">
                    <div class="search-text">
                        <i class="iconfont icon-search"></i>
                        <input type="text" placeholder="城市/民宿/商圈，支持中文/英文/拼音/首字母搜索" v-model="key" class="searchAll" data-type="searchAll" @click="searchBtn" @input="searchInput">
                        <i v-if="key!=''" class="iconfont icon-guanbi" @click="key=''"></i>
                        <HotCity @select="hotCity" :productType="'256'" :isHotCityShow="isHotCityShow"></HotCity>
                        <SearchAll :keyword="key" :productType="ProductType" :isKeyResultShow="isKeyResultShow" @selectCity="selectCity"
                                   @selectHotel="selectHotel" @selectLandmark="selectLandmark"></SearchAll>
                    </div>
                    <div class="search-date">
                        <i class="iconfont icon-calendar"></i>
                        <!--<span class="date-time" @click="calendar.show=true">{{CheckIn}}-->
                        <!--<span class="date-week">{{CheckIn|delUTC|dateWeek}}</span>-->
                        <!--</span>-->
                        <span class="date-time" data-type="time">
              <input type="text" data-type="time" class="date-time" v-model="CheckIn" @click="calendar.show=true"/>
              <span class="date-week">{{CheckIn|delUTC|dateWeek}}</span>
            </span>

                        <span class="date-days">{{getDays(CheckIn,CheckOut)}}晚</span>
                        <span class="date-time">
              <input type="text" data-type="time" class="date-time" v-model="CheckOut" @click="calendar.show=true"/>
              <span class="date-week">{{CheckOut|delUTC|dateWeek}}</span>
            </span>
                        <span class="sline"></span>
                        <transition name="fade" enter-active-class="animated bounceInUp"
                                    leave-active-class="animated fadeOutDown"
                                    :duration="500">
                            <DatePicker @select="calendar.select" v-show="calendar.show" :start="calendar.start"
                                        :beginDate="calendar.begin" :endDate="calendar.end"></DatePicker>
                        </transition>
                    </div>
                    <div class="search-select">
                        <i class="iconfont icon-my"></i>
                        <!--<select>-->
                        <!--<option value="">不限</option>-->
                        <!--<option value="1">1人</option>-->
                        <!--<option value="2">2人</option>-->
                        <!--<option value="3">3人</option>-->
                        <!--<option value="4">4人</option>-->
                        <!--</select>-->
                        <span class="pnum" v-if="AdultCount === ''" @click="PeopleNumShow = true">不限</span>
                        <span class="pnum" v-if="AdultCount != ''&&AdultCount !=10" @click="PeopleNumShow = true">{{AdultCount}}人</span>
                        <span class="pnum" v-if="AdultCount != ''&&AdultCount ==10" @click="PeopleNumShow = true">{{AdultCount}}人+</span>
                        <span class="triangle"></span>
                        <transition name="fadeInUp">
                            <SelectPeople @select="selectPeople" v-if="PeopleNumShow"></SelectPeople>
                        </transition>
                    </div>
                </div>
                <div class="search-btn" @click="routeToHotel()">
                    搜索
                </div>
            </div>
        </div>
        <div class="destination">
            <div class="des-title">发现精彩目的地</div>
            <div class="des-img">
                <div class="des-img-left">
                    <div class="c-img position-relative" @click="routerToHotHotel(RecomCity[0])">
                        <span>{{RecomCity[0].city}}({{RecomCityHotelTotal[0]}})</span>
                        <img src="../../assets/img/beijing.jpg"/>
                    </div>
                    <div class="d-img position-relative" @click="routerToHotHotel(RecomCity[1])">
                        <span>{{RecomCity[1].city}}({{RecomCityHotelTotal[1]}})</span>
                        <img src="../../assets/img/shanghai.jpg"/>
                    </div>
                    <div class="d-img position-relative" @click="routerToHotHotel(RecomCity[2])">
                        <span>{{RecomCity[2].city}}({{RecomCityHotelTotal[2]}})</span>
                        <img src="../../assets/img/guangzhou.jpg"/>
                    </div>
                    <div class="c-img position-relative" @click="routerToHotHotel(RecomCity[3])">
                        <span>{{RecomCity[3].city}}({{RecomCityHotelTotal[3]}})</span>
                        <img src="../../assets/img/shenzhen.jpg"/>
                    </div>
                </div>
                <div class="des-img-middle">
                    <div class="position-relative" @click="routerToHotHotel(RecomCity[4])">
                        <span>{{RecomCity[4].city}}({{RecomCityHotelTotal[4]}})</span>
                        <img src="../../assets/img/haerbin.jpg"/></div>
                </div>
                <div class="des-img-right">
                    <div class="position-relative" @click="routerToHotHotel(RecomCity[5])">
                        <span>{{RecomCity[5].city}}({{RecomCityHotelTotalA[0]}})</span>
                        <img src="../../assets/img/xiamen.jpg"/>
                    </div>
                    <div class="position-relative" @click="routerToHotHotel(RecomCity[6])">
                        <span>{{RecomCity[6].city}}({{RecomCityHotelTotalA[1]}})</span>
                        <img src="../../assets/img/chasha.jpg"/>
                    </div>
                    <div class="position-relative" @click="routerToHotHotel(RecomCity[7])">
                        <span>{{RecomCity[7].city}}({{RecomCityHotelTotalA[2]}})</span>
                        <img src="../../assets/img/qinhuangdao.jpg"/></div>
                    <div class="position-relative" @click="routerToHotHotel(RecomCity[8])">
                        <span>{{RecomCity[8].city}}({{RecomCityHotelTotalA[3]}})</span>
                        <img src="../../assets/img/lijiang.jpg"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DatePicker from './../../common/cmpnt/datePicker/datePicker.vue'//日期
    import SelectPeople from './../../common/cmpnt/selectPeople/SelectPeople.vue'//选择人数
    import HotCity from './../../common/cmpnt/hotCity/HotCity.vue'//热门城市
    import SearchAll from './../../common/cmpnt/searchAll/SearchAll.vue'//热门城市

    export default {
        name: "homeStay",
        components: {
            DatePicker,
            SelectPeople,
            HotCity,
            SearchAll,
        },
        data: function () {
            return {
                HomeStayNum: 0,
                HomeStayNums: 0,
                Total: 0,
                PeopleNum: '',
                isHotCityShow:false,
                isKeyResultShow:false,
                PeopleNumShow: false,
                key:'',
                RegionID: '',
                ProductType:'256',
                CityName: '',
                MyCityRegionID: '',
                districtId: '',
                From: 1,
                Name: '',
                Landmark: '',
                LandmarkCode: '',
                LandmarkName: '',
                Star: '',
                PriceMin: '',
                PriceMax: '',
                CheckIn: this.getDate(1),
                CheckOut: this.getDate(2),
                RoomCount: '',
                AdultCount: 2,
                ChildrenCount: 0,
                ChildrenAges: [],
                HotelIDs: '',
                Sort: '',
                MyLat: '',
                MyLon: '',
                MyPositionLat: '',
                MyPositionLon: '',
                RecomCityHotelTotal:[0,0,0,0,0,0,0,0,0],
                RecomCityHotelTotalA:[0,0,0,0],
                RecomCity:[
                    {city: '北京', RegionID: '0101'},
                    {city: '上海', RegionID: '0201'},
                    {city: '广州', RegionID: '2001'},
                    {city: '深圳', RegionID: '2003'},
                    {city: '哈尔滨', RegionID: '1001'},
                    {city: '厦门', RegionID: '1401'},
                    {city: '长沙', RegionID: '1901'},
                    {city: '秦皇岛', RegionID: '0503'},
                    {city: '丽江', RegionID: '2503'},
                ],
                calendar: {
                    show: false,
                    start: this.getDate(0),
                    begin: this.getDate(1),
                    end: this.getDate(2),
                    select: (begin, end) => {
                        this.calendar.show = false;
                        if (!begin) {
                            return;
                        }
                        this.calendar.begin = begin;
                        this.calendar.end = end;
                        this.CheckIn = begin;
                        this.CheckOut = end;
                        this.$nextTick(function () {
                            this.calendar.show = false;
                            // this.changeFilter();
                        });
                    }
                },

            }
        },
        watch: {
            HomeStayNum(val) {
                this.HomeStayNums = this.toThousands(val);
            },
            key(val, oldVal) {
                if (val && oldVal == '' && this.isHotCityShow) {
                    this.isHotCityShow = false;
                    this.isKeyResultShow = true
                }
            },
        },
        mounted() {
            this.initData();
            this.getHotHotelTotal();
            document.title='民宿预订---订房易';
            
        },
        methods: {
            searchBtn() {
                this.searchScroll();
                this.isKeyResultShow = false
                this.isHotCityShow = true
            },
            searchInput(){
                this.isKeyResultShow = true
                this.isHotCityShow = false
            },
            hotCity(obj) {
                this.isKeyResultShow = false;
                this.isHotCityShow = false;
                if (!obj) {
                    return
                }
                this.RegionID = obj.I;
                this.CityName = obj.N;
                this.key = obj.N;

                this.Name = '';
                this.LandmarkName = '';
                this.LandmarkCode = '';
            },
            //选择城市
            selectCity(city) {
                this.RegionID = city.ID;
                this.From = city.From;
                this.CityName = city.SName;
                this.key = city.CName||city.SName;
                this.isKeyResultShow = false;

                this.Name = '';
                this.LandmarkName = '';
                this.LandmarkCode = '';
            },
            //选择酒店
            selectHotel(hotel) {
                this.isKeyResultShow = false;
                var obj={
                    ID:hotel.HotelID,
                    From:hotel.From
                }
                //查询酒店信息
                this.routeToDetails(obj);
            },
            //选择地标
            selectLandmark(landmark) {
                this.RegionID = landmark.CityID;
                this.CityName = landmark.City;
                this.LandmarkCode = landmark.ID;
                this.LandmarkName = landmark.Name;
                this.From = landmark.From;
                this.key = landmark.Name;
                this.isKeyResultShow = false;

                this.Name = '';

            },
            selectPeople(val) {
                this.PeopleNumShow = false;
                if (val == 0) {
                    this.AdultCount = '';
                }
                if (!val) {
                    return
                }
                this.AdultCount = val;
            },
            routerToHotHotel(item) {
                var obj = {
                    RegionID: item.RegionID,
                    CityName: item.city,
                    ProductType:'256',
                    MyCityRegionID: '',
                    districtId: '',
                    From: 1,
                    Name: '',
                    Landmark: '',
                    LandmarkCode: '',
                    LandmarkName: '',
                    Star: '',
                    PriceMin: '',
                    PriceMax: '',
                    CheckIn: this.getDate(1),
                    CheckOut: this.getDate(2),
                    RoomCount: 1,
                    AdultCount: 2,
                    ChildrenCount: 0,
                    ChildrenAges: [],
                    HotelIDs: '',
                    Sort: '',
                    MyLat: '',
                    MyLon: '',
                    MyPositionLat: this.MyPositionLat,
                    MyPositionLon: this.MyPositionLon,
                    key: item.city,
                }
                this.dao.set('hotelListSearchParams', obj);
                this.$router.push('/hotelList');
            },
            //打开详情
            routeToDetails(item) {
                var obj = {
                    HotelID: item.ID,
                    From: item.From,
                    CheckIn: this.CheckIn,
                    CheckOut: this.CheckOut,
                    ProductType:'256',
                    RoomCount: 1,
                    AdultCount: 2,
                    ChildrenCount: 0,
                    ChildrenAges: [],
                    MyLat: this.MyLat,
                    MyLon: this.MyLon,
                    MyCityRegionID: this.MyCityRegionID,
                }
                this.dao.set('hotelDetailsParams', obj)
                this.$router.push('/hotelDetails')

            },
            //滚动动画
            scrollAnimation(currentY, targetY) {
                let needScrollTop = targetY - currentY
                let _currentY = currentY
                setTimeout(() => {
                    const dist = Math.ceil(needScrollTop / 10)
                    _currentY += dist
                    window.scrollTo(_currentY, currentY)
                    if (needScrollTop > 10 || needScrollTop < -10) {
                        this.scrollAnimation(_currentY, targetY)
                    } else {
                        window.scrollTo(_currentY, targetY)
                    }
                }, 1)
            },
            searchScroll(e) {
                var currentY = document.documentElement.scrollTop || document.body.scrollTop
                if (currentY < 450) {
                    this.scrollAnimation(currentY, 450)
                }
            },
            routeToHotel() {
                //若没有选择城市或者地标，则显示提示框提醒
                if(!this.key||!this.RegionID){
                    this.error({title: '提示', content: '请选择城市或地标'});
                    return;
                }
                var obj = {
                    RegionID: this.RegionID,
                    CityName: this.CityName,
                    MyCityRegionID: this.MyCityRegionID,
                    districtId: this.districtId,
                    ProductType:'256',
                    From: this.From,
                    Name: this.Name,
                    Landmark: this.Landmark,
                    LandmarkCode: this.LandmarkCode,
                    LandmarkName: this.LandmarkName,
                    Star: this.Star,
                    PriceMin: this.PriceMin,
                    PriceMax: this.PriceMax,
                    CheckIn: this.CheckIn,
                    CheckOut: this.CheckOut,
                    RoomCount: this.RoomCount,
                    AdultCount: this.AdultCount,
                    ChildrenCount: this.ChildrenCount,
                    ChildrenAges: this.ChildrenAges,
                    HotelIDs: this.HotelID,
                    Sort: this.Sort,
                    MyLat: this.MyLat,
                    MyLon: this.MyLon,
                    MyPositionLat: this.MyPositionLat,
                    MyPositionLon: this.MyPositionLon,
                    key: this.key,
                }
                this.dao.set('hotelListSearchParams', obj);
                this.$router.push('/hotelList');
            },
            toThousands(num) {
                var result = [], counter = 0;
                num = (num || 0).toString().split('');
                for (var i = num.length - 1; i >= 0; i--) {
                    counter++;
                    result.unshift(num[i]);
                    if (!(counter % 3) && i != 0) {
                        result.unshift(',');
                    }
                }
                return result.join('');
            },
            homeStayNumTimeOut() {
                var that = this;
                var k = Math.ceil(that.Total/30);
                var TimeOut = setTimeout(function () {
                    if (that.HomeStayNum < that.Total) {
                        if (that.HomeStayNum + k >= that.Total) {
                            that.HomeStayNum = that.Total;
                            clearTimeout(TimeOut);
                        } else {
                            that.HomeStayNum += k;
                            that.homeStayNumTimeOut();
                        }
                    } else if (that.HomeStayNum == that.Total) {
                        clearTimeout(TimeOut);
                    }
                }, 10)
            },
            getHotHotelTotalA(){
                var that = this;
                for (let j = 0; j < that.RecomCityHotelTotalA.length; j++) {
                    that.RecomCityHotelTotalA[j] = that.RecomCityHotelTotal[j + 5]
                }
            },
            getHotHotelTotal() {
                var that = this;
                for (let i = 0; i < that.RecomCity.length; i++) {
                    var params = {
                        RegionID: that.RecomCity[i].RegionID,
                        From: 1,
                        ProductType: '256',
                        Name: '',
                        Landmark: '',
                        Star: '',
                        PriceMin: '',
                        PriceMax: '',
                        CheckIn: that.CheckIn,
                        CheckOut: that.CheckOut,
                        RoomCount: 1,
                        AdultCount: 2,
                        ChildrenCount: 0,
                        ChildrenAges: [5, 5],
                        Page: 1,
                        PageSize: 0,
                        Sort: 0,
                    }
                    that.postRequest({
                        url: that.Api.price,
                        params: params
                    }).then(res => {
                        if (res && res.IsSuccess) {
                            that.RecomCityHotelTotal[i] = res.Total;
                            that.$forceUpdate();
                            that.getHotHotelTotalA()
                            that.$nextTick(() => {
                                if(localStorage.getItem('lang')=='t'){
                                    that.$zh_tran(localStorage.getItem('lang'))
                                }         
                            })
                        }
                    });
                }
            },
            initData(){
                var that = this;
                var params={
                    RegionID:'',
                    From:1,
                    ProductType:'256',
                    Name:'',
                    Landmark:'',
                    LandmarkCode:'',
                    Star:'',
                    PriceMin:'',
                    PriceMax:'',
                    CheckIn:that.CheckIn,
                    CheckOut:that.CheckOut,
                    RoomCount:1,
                    AdultCount:2,
                    ChildrenCount:0,
                    ChildrenAges:[],
                    Page:1,
                    PageSize:0,
                    HotelIDs:'',
                    Sort:0,
                    MyLat:'',
                    MyLon:'',
                    Radius:'',
                    MyCityRegionID:'',
                }
                that.postRequest({
                    url: that.Api.price,
                    params: params
                }).then(res => {
                    if (res&&res.IsSuccess) {
                        that.Total=res.Total;
                        that.homeStayNumTimeOut();
                        that.$nextTick(() => {
                            if(localStorage.getItem('lang')=='t'){
                                that.$zh_tran(localStorage.getItem('lang'))
                            }        
                        })
                    } else {
                    }
                });
            }
        }
    }
</script>





// WEBPACK FOOTER //
// src/components/homestay/index.vue